
export const empresas = {
  hero: {
    title: 'Engenharia Patrimonial para Empresas',
    subtitle: 'Estruturação técnica para aquisição de ativos corporativos, sede própria e expansão via consórcios regulamentados. Governança, clareza e método aplicado ao patrimônio empresarial.',
    cta_primary: 'Solicitar Diagnóstico PJ',
    cta_secondary: 'Falar com Especialista'
  },
  applications: {
    label: 'Aplicações',
    title: 'Estruturação de Ativos Corporativos',
    items: [
      {
        title: 'Aquisição de Sede Própria',
        description: 'Estruturação técnica para aquisição de imóvel comercial via consórcio, com análise de impacto no fluxo de caixa e planejamento tributário.',
        icon: 'building'
      },
      {
        title: 'Expansão e Novos Pontos',
        description: 'Modelagem para abertura de filiais, pontos comerciais ou unidades operacionais com preservação de capital de giro e governança financeira.',
        icon: 'store'
      },
      {
        title: 'Aquisição de Ativos Operacionais',
        description: 'Estruturação para aquisição de veículos, máquinas, equipamentos e outros ativos produtivos com análise de retorno sobre investimento.',
        icon: 'truck'
      }
    ]
  },
  when: {
    label: 'Quando Faz Sentido',
    title: 'Cenários de Aplicação Corporativa',
    scenarios: [
      {
        title: 'Preservação de Capital de Giro',
        description: 'Quando a empresa precisa adquirir ativos sem comprometer liquidez operacional ou capacidade de investimento em outras frentes estratégicas.',
        points: [
          'Fluxo de caixa saudável mas capital comprometido em operação',
          'Necessidade de preservar linhas de crédito para outras finalidades',
          'Planejamento de expansão simultânea em múltiplas frentes'
        ]
      },
      {
        title: 'Planejamento Tributário',
        description: 'Quando a estruturação via consórcio oferece vantagens tributárias ou contábeis em relação a financiamento tradicional.',
        points: [
          'Análise de impacto no balanço patrimonial',
          'Comparação de custos efetivos versus crédito bancário',
          'Estruturação de fluxo de pagamentos alinhado ao regime tributário'
        ]
      },
      {
        title: 'Governança e Disciplina',
        description: 'Quando a empresa busca estrutura de aquisição com regras claras, previsibilidade de custos e ausência de variação cambial.',
        points: [
          'Necessidade de previsibilidade orçamentária de médio prazo',
          'Preferência por estruturas regulamentadas e transparentes',
          'Alinhamento com políticas internas de governança corporativa'
        ]
      },
      {
        title: 'Expansão Estruturada',
        description: 'Quando o crescimento da empresa demanda aquisição de múltiplos ativos com planejamento financeiro integrado.',
        points: [
          'Plano de expansão com múltiplas aquisições programadas',
          'Necessidade de estruturar fluxo de investimentos escalonado',
          'Coordenação entre diferentes frentes de crescimento'
        ]
      }
    ]
  },
  method: {
    label: 'Método FGT',
    title: 'Como Estruturamos para Empresas',
    description: 'Aplicação do método FGT adaptado ao contexto corporativo, com análise de impacto no balanço, fluxo de caixa e planejamento tributário.',
    steps: [
      {
        title: 'Diagnóstico Corporativo',
        description: 'Análise de estrutura patrimonial da empresa, objetivos de aquisição, capacidade de pagamento e impacto no fluxo de caixa operacional.'
      },
      {
        title: 'Análise de Viabilidade',
        description: 'Modelagem de cenários comparando consórcio versus alternativas de crédito, considerando custos totais, impactos tributários e contábeis.'
      },
      {
        title: 'Estruturação da Operação',
        description: 'Definição de estrutura jurídica, análise de regulamentos disponíveis, seleção de administradora e planejamento de fluxo de pagamentos.'
      },
      {
        title: 'Execução e Acompanhamento',
        description: 'Gestão do processo de adesão, acompanhamento de grupo até contemplação ou aquisição de carta, e suporte na utilização do crédito.'
      }
    ]
  },
  governance: {
    label: 'Governança',
    title: 'Clareza e Limites Técnicos',
    points: [
      'A contemplação depende de sorteio ou lance, conforme regulamento. Não há garantia de prazo.',
      'Custos totais variam conforme grupo, administradora e condições específicas do regulamento.',
      'A análise técnica considera variáveis conhecidas, mas não elimina riscos inerentes ao sistema de consórcios.',
      'Toda operação está sujeita à aprovação cadastral e documental pela administradora escolhida.'
    ]
  },
  cta: {
    title: 'Estruture os Ativos da sua Empresa',
    subtitle: 'Agendar um diagnóstico estratégico para análise técnica de viabilidade e estruturação de aquisição via consórcios.',
    button_primary: 'Solicitar Diagnóstico PJ',
    button_secondary: 'WhatsApp'
  }
};
